import type { ReactNode } from "react"
import { TooltipProvider } from "@holigral/shared/ui/components/ui/tooltip"
import { ThemeProvider } from "@holigral/shared/ui/components/theme-provider"
import { Toaster } from "@holigral/shared/ui/components/ui/sonner"

type Props = {
  children: ReactNode
}

export default function UiProvider({ children }: Props) {
  return (
    <ThemeProvider>
      <TooltipProvider>
        {children}
        <Toaster />
      </TooltipProvider>
    </ThemeProvider>
  )
}
